import { Component } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash-es/isEqual';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import GeneralSettings from './GeneralSettings';
import {
  SelectedSourceType,
  SourcesSettingsMobileControls,
  SourceSettingsModalTitle,
  SourceSettingsModalBtns,
} from '../SourcesHelperComponents';
import ManageSources from './ManageSources';

import StorageSvc from '../../../../services/StorageSvc';

import withComponentName from '../../../../decorators/withComponentName';

import * as storyFiltersActions from '../../../../actions/storyFilters.action';

import { CONTENT_SOURCE_FILTER } from '../../../../data/features';

import Styles from '../../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

class SourceSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      refresh: false,
      openedTab: 'general',
      domainFilteringMode: '',
      whitelist: '',
      blacklist: '',
      saveDisabled: false,
      whitelistModified: false,
      blacklistModified: false,
      initialLoadDomainsTab: false,
      requiredSourceValues: [],
      showHideLabelModal: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    const { storyFilters } = this.props;

    this.setState({
      domainFilteringMode: storyFilters.domains_filtering_mode,
      whitelist: storyFilters.whitelisted_domain_ids,
      blacklist: storyFilters.blacklisted_domain_ids,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      whitelist, blacklist, openedTab, whitelistModified,
      initialLoadDomainsTab, saveDisabled, domainFilteringMode,
    } = this.state;
    const { storyFilters } = this.props;

    // if domains filter options changes from other component
    if (storyFilters.domains_filtering_mode !== prevProps.storyFilters.domains_filtering_mode) {
      return this.setState({
        domainFilteringMode: storyFilters.domains_filtering_mode,
        whitelist: storyFilters.whitelisted_domain_ids,
        blacklist: storyFilters.blacklisted_domain_ids,
      }, () => { this.save(); });
    }

    // save button always active on general screen
    if (
      openedTab !== prevState.openedTab
      && openedTab === 'general'
    ) return this.setState({ saveDisabled: false, initialLoadDomainsTab: false });

    if (
      openedTab === 'manageSources'
      && domainFilteringMode !== prevState.domainFilteringMode
      && saveDisabled
    ) {
      return this.setState({
        saveDisabled: false,
        initialLoadDomainsTab: true,
      });
    }

    // disable save button if no new domains were selected
    if (
      openedTab !== prevState.openedTab
      && openedTab === 'manageSources'
      && !initialLoadDomainsTab
      && isEqual(storyFilters.whitelisted_domain_ids, whitelist)
    ) return this.setState({ saveDisabled: true, initialLoadDomainsTab: true });

    // enable save button if user make whitelist changes
    if (
      !isEqual(storyFilters.whitelisted_domain_ids, whitelist)
      && openedTab === 'manageSources'
      && !whitelistModified
      && initialLoadDomainsTab
      && saveDisabled
    ) {
      return this.setState({
        saveDisabled: false,
        whitelistModified: true,
        blacklistModified: false,
        initialLoadDomainsTab: true,
      });
    }

    // enable save button if user make blacklist changes
    if (
      !isEqual(storyFilters.blacklisted_domain_ids, blacklist)
      && openedTab === 'manageSources'
      && !whitelistModified
      && initialLoadDomainsTab
      && saveDisabled
    ) {
      return this.setState({
        saveDisabled: false,
        whitelistModified: false,
        blacklistModified: true,
        initialLoadDomainsTab: true,
      });
    }
  }

  onShowPremiumLabelHideModal(e) {
    e.stopPropagation();
    this.setState({
      showHideLabelModal: true,
    });
  }

  onClosePremiumLabelHideModal() {
    this.setState({
      showHideLabelModal: false,
    });
  }

  onHidePremiumLabel(e) {
    const { actions, storyFilters } = this.props;
    const { isPremiumLabelsEnabled } = storyFilters;
    e.stopPropagation();
    StorageSvc.setItem('showPremiumLabels', JSON.stringify({ status: !isPremiumLabelsEnabled }));
    actions.togglePremiumLabels(!isPremiumLabelsEnabled);
    this.onClosePremiumLabelHideModal();
  }

  handleShow() {
    const { storyFilters } = this.props;

    const rehydrate = JSON.parse(StorageSvc.getItem('AdvancedSettingsFilter'));
    if (rehydrate) return this.setState({ ...rehydrate, show: true });
    return this.setState({
      show: true,
      refresh: false,
      storiesFromFollowing: storyFilters.twitter_following_only || false,
      tweetsOnlyWithLinks: storyFilters.with_links || false,
    });
  }

  handleClose() {
    const { storyFilters } = this.props;

    this.setState({
      show: false,
      domainFilteringMode: storyFilters.domains_filtering_mode,
      whitelist: storyFilters.whitelisted_domain_ids,
      blacklist: storyFilters.blacklisted_domain_ids,
      openedTab: 'general',
    });
  }

  onChangeSwitchButton(item, status) {
    this.setState({
      [item]: status,
    });
  }

  setDomainsInfo(info) {
    this.setState({
      domainFilteringMode: info,
    });
  }

  setSelectedDomains(selectedDomains) {
    const { domainFilteringMode } = this.state;
    this.setState({
      domainFilteringMode,
      ...selectedDomains,
    });
  }

  setRequiredSourceValues(item) {
    const { requiredSourceValues } = this.state;
    const sourceIndex = requiredSourceValues.findIndex((sourceValue) => sourceValue.id === item.id);

    if (sourceIndex > -1) {
      requiredSourceValues.splice(sourceIndex, 1, item);
    } else {
      requiredSourceValues.push(item);
    }

    this.setState({
      requiredSourceValues: [...requiredSourceValues],
    });
  }

  saveState() {
    StorageSvc.setItem(
      'AdvancedSettingsFilter',
      JSON.stringify({ ...this.state, refresh: false, show: false }),
    );
  }

  selectSettingsTab(tab) {
    this.setState({ openedTab: tab });
  }

  save() {
    const {
      domainFilteringMode,
      whitelist, blacklist,
      requiredSourceValues,
    } = this.state;
    const {
      token, actions,
      extraSetValueSelected,
    } = this.props;

    actions.filterBySelectedSources({
      whitelisted_domain_ids: whitelist.join(','),
      blacklisted_domain_ids: blacklist.join(','),
      domains_filtering_mode: domainFilteringMode,
    }, token);
    if (!token) this.saveState();

    requiredSourceValues.forEach((item) => {
      extraSetValueSelected(item);
    });

    this.setState({ show: false });
  }

  cancel() {
    this.handleClose();
  }

  selectMobileTab(openedTab) {
    this.setState({ openedTab }, () => this.handleShow());
  }

  render() {
    const {
      show, domainFilteringMode, openedTab,
      saveDisabled,
    } = this.state;
    const {
      extraOptions,
      sourcesEnabled,
      permissions,
      storyFilters,
      width,
    } = this.props;

    const { features } = permissions;
    const domainsSelectionFeature = features.includes(CONTENT_SOURCE_FILTER);

    return (
      <>
        <div
          className={Styles['source-settings-btn']}
        >
          <div
            className={Styles['source-settings-btn__wrapper']}
          >
            <div className={Styles['source-settings-btn__inner']} onClick={() => this.handleShow()}>
              <span>SETTINGS</span>
              <FontAwesomeIcon icon={faCog} />
            </div>
            <SelectedSourceType domainFilteringMode={domainFilteringMode} />
          </div>
        </div>

        <SourcesSettingsMobileControls
          domainFilteringMode={domainFilteringMode}
          selectMobileTab={this.selectMobileTab}
        />

        <Modal
          className={Styles['advanced-settings-modal']}
          show={show}
          onHide={this.handleClose}
          centered
        >
          <div className={Styles['advanced-settings-close']} onClick={this.handleClose}>
            <FontAwesomeIcon icon={faXmark} />
          </div>

          <Modal.Body className={Styles['advanced-modal-body']}>
            <SourceSettingsModalTitle
              width={width}
              handleClose={this.handleClose}
              cancel={this.cancel}
              save={this.save}
              openedTab={openedTab}
              saveDisabled={saveDisabled}
              domainsSelectionFeature={domainsSelectionFeature}
            />

            <Tabs
              defaultActiveKey="general"
              id="uncontrolled-tab"
              onSelect={this.selectSettingsTab}
              activeKey={openedTab}
              className={cx({ 'general-tab': openedTab === 'general' })}
            >
              <Tab eventKey="general" title="General">
                <div className={Styles['advanced-general-items']}>
                  <div className={Styles['general-item']}>
                    <h2>News and research</h2>
                    {extraOptions.map((extraOptionItem) => (
                      <GeneralSettings
                        key={extraOptionItem.id}
                        title={extraOptionItem.name}
                        status={extraOptionItem.select}
                        item={extraOptionItem}
                        switchId={`Stories_sources_switch_${extraOptionItem.id}`}
                        onChangeSwitchButton={() => this.setRequiredSourceValues(extraOptionItem)}
                      />
                    ))}
                  </div>
                </div>
              </Tab>
              {sourcesEnabled && (
                <Tab eventKey="manageSources" title="Manage sources">
                  <ManageSources
                    setDomainsInfo={this.setDomainsInfo}
                    features={features}
                    domainFilteringMode={domainFilteringMode}
                    setSelectedDomains={this.setSelectedDomains}
                    whitelistDomains={storyFilters.whitelisted_domain_ids}
                    blacklistDomains={storyFilters.blacklisted_domain_ids}
                  />
                </Tab>
              )}
            </Tabs>
            <SourceSettingsModalBtns
              cancel={this.cancel}
              save={this.save}
              openedTab={openedTab}
              saveDisabled={saveDisabled}
              domainsSelectionFeature={domainsSelectionFeature}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

function mapToStateProps(state) {
  const { permissions, permissionsInitialized } = state.subscriptions;

  return {
    permissionsInitialized,
    permissions,
    storyFilters: state.storyFilters,
    token: state.watchlistReducer.userToken,
    user: state.userPreferencesReducer.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...storyFiltersActions,
    }, dispatch),
  };
}

export default withComponentName(connect(mapToStateProps, mapDispatchToProps)(SourceSettings));
